import { LegalLayout } from "./LegalLayout";
import { CONTACT_BLOCK, LegalSection, Pending } from "./shared";
import { EMAIL } from "../../data/site";

const { H2, P, UL } = LegalSection;

export default function Privacidade() {
  return (
    <LegalLayout title="Política de Privacidade" updated="agosto de 2026">
      <P>
        A TopEstofos respeita a privacidade dos visitantes do seu website e está empenhada em
        proteger os dados pessoais que lhe são confiados, em conformidade com o Regulamento Geral
        sobre a Proteção de Dados (RGPD — Regulamento (UE) 2016/679) e a legislação portuguesa
        aplicável.
      </P>

      <H2>1. Responsável pelo tratamento de dados</H2>
      <P>
        O responsável pelo tratamento dos dados pessoais recolhidos neste website é a TopEstofos,
        com sede em Rua José Campas n.º 2, 1800-236 Lisboa, Portugal.
      </P>
      <UL>
        <li>
          Número de identificação fiscal (NIF): <Pending>NIF</Pending>
        </li>
        <li>E-mail: {EMAIL}</li>
      </UL>

      <H2>2. Dados que recolhemos</H2>
      <P>
        Através do formulário de contacto/pedido de orçamento disponível neste website, recolhemos
        os seguintes dados pessoais, fornecidos voluntariamente pelo utilizador:
      </P>
      <UL>
        <li>Nome;</li>
        <li>Endereço de e-mail;</li>
        <li>Número de telefone;</li>
        <li>Serviço pretendido e mensagem, incluindo quaisquer outras informações que o utilizador
          decida partilhar (por exemplo, tipo de estofo, morada para atendimento ao domicílio ou
          disponibilidade horária).</li>
      </UL>
      <P>
        Se o contacto for feito diretamente através do WhatsApp ou por e-mail, aplicam-se os mesmos
        princípios às informações partilhadas nesse contacto.
      </P>

      <H2>3. Finalidade do tratamento</H2>
      <P>Os dados recolhidos são utilizados exclusivamente para:</P>
      <UL>
        <li>Responder a pedidos de contacto e de orçamento;</li>
        <li>Preparar e apresentar propostas de serviços de higienização de estofos;</li>
        <li>Agendar e prestar os serviços solicitados, incluindo atendimento ao domicílio em Lisboa
          e região;</li>
        <li>Comunicações diretamente relacionadas com o serviço solicitado.</li>
      </UL>
      <P>
        Os dados não são utilizados para fins de marketing sem o consentimento do titular, nem são
        vendidos, cedidos ou partilhados com terceiros para fins comerciais.
      </P>

      <H2>4. Fundamento legal</H2>
      <P>
        O tratamento dos dados baseia-se na realização de diligências pré-contratuais a pedido do
        titular dos dados (pedido de orçamento) e, quando aplicável, na execução de um contrato de
        prestação de serviços, nos termos do artigo 6.º, n.º 1, alínea b) do RGPD.
      </P>

      <H2>5. Conservação dos dados</H2>
      <P>
        Os dados são conservados apenas durante o período necessário para responder ao pedido e
        prestar o serviço, bem como durante os prazos legais aplicáveis. Decorrido esse período, os
        dados são eliminados de forma segura.
      </P>

      <H2>6. Partilha de dados</H2>
      <P>
        Os dados podem ser tratados através de fornecedores de serviços tecnológicos que asseguram o
        funcionamento do website e do envio de comunicações (alojamento e envio de e-mail),
        sempre sob obrigações de confidencialidade e segurança. Não são efetuadas transferências
        internacionais de dados para além das necessárias ao funcionamento destas ferramentas.
      </P>

      <H2>7. Direitos do titular</H2>
      <P>Nos termos do RGPD, o titular dos dados tem direito a:</P>
      <UL>
        <li>Aceder aos seus dados pessoais;</li>
        <li>Solicitar a retificação de dados inexatos;</li>
        <li>Solicitar o apagamento dos dados ("direito a ser esquecido");</li>
        <li>Solicitar a limitação ou opor-se ao tratamento;</li>
        <li>Solicitar a portabilidade dos dados, quando aplicável;</li>
        <li>Retirar o consentimento, quando o tratamento se basear no consentimento;</li>
        <li>Apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD).</li>
      </UL>
      <P>
        Para exercer qualquer um destes direitos, basta contactar-nos através do e-mail {EMAIL}.
      </P>

      <H2>8. Segurança</H2>
      <P>
        A TopEstofos adota medidas técnicas e organizativas adequadas para proteger os dados
        pessoais contra acesso não autorizado, perda, destruição ou divulgação indevida.
      </P>

      <H2>9. Alterações a esta política</H2>
      <P>
        Esta Política de Privacidade pode ser atualizada periodicamente. A versão em vigor estará
        sempre disponível nesta página, com a respetiva data de atualização.
      </P>

      {CONTACT_BLOCK}
    </LegalLayout>
  );
}
